export const filterOnlyActive = (array: any[]) =>
  array.filter((object) => object?.isActive === 'SI');
